import { render, staticRenderFns } from "./TransitionSkeleton.vue?vue&type=template&id=b005a27e&"
import script from "./TransitionSkeleton.vue?vue&type=script&lang=js&"
export * from "./TransitionSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports